<template>
    <div class="wrap">
        <div class="module clear_a">
            <div class="line"></div>
            <div class="header clear_a">
                <div class="left_header">
                    <el-input :placeholder="inputPlaceholder" class="w250 seekIpt mr20" v-model="inputData['model']">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
                    </el-input>
                </div>
                <div class="right_header clear_a">
                    <span class="title">{{title}}</span>
                    <span class="statistic">共{{inputData['data'].length}}{{inputData['unit']}}</span>
                </div>
            </div>
            <div class="left_module"  v-if="inputData['data'].length >0 && dataNull === false">
                <el-checkbox :indeterminate="isIndeterminate" v-model="inputData['checkAll']" @change="handleCheckAllChange">全选</el-checkbox>
                <div style="margin: 15px 0;"></div>
                <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="item in cities" :label="item.empId" :key="item.empId">{{item.empName}}</el-checkbox>
                </el-checkbox-group>
            </div>
            <div class="left_module textTip"  v-if="dataNull === true">
                没有匹配的数据
            </div>
            <div class="right_module">
                <el-checkbox-group v-model="checkedCities" @change="handleCitiesChange">
                    <el-checkbox v-for="item in checkedList" :label="item.empId" :key="item.empId">{{item.empName}}</el-checkbox>
                </el-checkbox-group>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "inspectAdd",
        props: {
            title: {
                type: String,
                default: true
            },
            inputData:{
                type:Object
            },
            inputPlaceholder:{
                type:String,
                default: '请输入搜索内容'
            },
            data:{
                type:Object
            }
        },
        data() {
            return{
                queryLimit:{
                    keyword:''
                },
                unit:'人',
                title:'已选择人员',
                checkAll: false,
                checkedCities: ['222','232'],
                cities:  [
                    {
                        empId:'222',
                        empName:'十个人',
                        empPost:'人啊'
                    },
                    {
                        empId:'232',
                        empName:'是个人',
                        empPost:'了啊'
                    },
                    {
                        empId:'282',
                        empName:'发发人',
                        empPost:'人啊'
                    },
                    {
                        empId:'292',
                        empName:'是额个人',
                        empPost:'了啊'
                    },
                    {
                        empId:'3455',
                        empName:'咯额人',
                        empPost:'鹅鹅鹅'
                    },
                    {
                        empId:'3433335',
                        empName:'咯发发人',
                        empPost:'仍然'
                    }
                ],
                isIndeterminate: true,
                dataNull: false,
                checkedList:[
                    {
                        empId:'222',
                        empName:'十个人',
                        empPost:'人啊'
                    },
                    {
                        empId:'232',
                        empName:'是个人',
                        empPost:'了啊'
                    }
                ],
                citiesCopy:[]
            }
        },

        methods: {
            handleCheckAllChange() {
                this.checkAll =  !!this.checkAll;
                let checked = this.cities.map(function(item){return item.empId;});
                this.checkedCities = this.checkAll ? checked : [];
                this.checkedList = this.checkAll? JSON.parse(JSON.stringify(this.cities)) : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value) {
                let checkedCount = value.length;
                this.checkedList = []
                this.checkedCities.map(item =>{
                    this.citiesCopy.map(items =>{
                        if(items.empId == item){
                            this.checkedList.push(items)
                        }
                    })
                })
                this.checkAll = checkedCount === this.cities.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;

            },
            handleCitiesChange(){
                this.checkedList = []
                this.checkedCities.map(item =>{
                    this.cities.map(items =>{
                        if(items.empId == item){
                            this.checkedList.push(items)
                        }
                    })
                })
            },
            search(){
                this.cities.map(item =>{
                    if(item.empName == this.queryLimit.keyword){
                        this.cities = [item]
                        this.dataNull = false;
                    }else if(this.queryLimit.keyword == ''){
                        this.cities = JSON.parse(JSON.stringify(this.citiesCopy));
                        this.dataNull = false;
                    }
                })

                // if(this.cities.includes(this.queryLimit.keyword)){
                //     this.cities = [this.queryLimit.keyword]
                //     this.dataNull = false;
                // }else if(this.queryLimit.keyword == ''){
                //     this.cities = this.citiesCopy;
                //     this.dataNull = false;
                // }else{
                //     this.dataNull = true
                // }
            },
            getData(){
                this.citiesCopy = JSON.parse(JSON.stringify(this.cities))
            }
        },
        mounted(){
            this.getData()
        }
    }
</script>

<style scoped lang="scss">
    .line{
        width: 100%;
        height: 1px;
        background: #eeeeee;
    }
    .el-checkbox{
        width: 80px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-right: 25px;
    }
    .wrap{
        .module{
            background: #fff;
            width: 720px;
            height: 400px;
            margin: 0;
            padding: 0;
            .header{
                width: 100%;
                height: 60px;
                .left_header{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 358px;
                    height: 100%;
                    border-right: 1px solid #eeeeee;
                    box-sizing: border-box;
                }
                .right_header{
                    width: 358px;
                    height: 100%;
                    .title{
                        float: left;
                        font-size: 16px;
                        color:#333333;
                        line-height: 22px;
                        margin: 19px 0 0 30px;
                        display: inline-block;
                    }
                    .statistic{
                        font-size: 14px;
                        color:#999999;
                        line-height: 20px;
                        margin-top: 19px;
                        float: right;
                        display: inline-block;
                    }
                }
            }
            .textTip{
                text-align: center;
            }
            .left_module{
                width: 358px;
                height: 340px;
                display: inline-block;
                border-top: 1px solid #eeeeee;
                border-bottom: 1px solid #eeeeee;
                border-right: 1px solid #eeeeee;
                box-sizing: border-box;
                padding: 20px;
                overflow: scroll;
            }
            .right_module{
                width: 358px;
                height: 340px;
                display: inline-block;
                border-top: 1px solid #eeeeee;
                border-bottom: 1px solid #eeeeee;
                box-sizing: border-box;
                padding: 20px;
                overflow: scroll;
            }
        }
    }
</style>